"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockAgreement = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 24, height: 18, y: 3, fill: "#403493", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M20 12.666A.667.667 0 0 1 20 14h-5.333a.667.667 0 0 1 0-1.334zm0-3.333a.667.667 0 0 1 0 1.333h-5.333a.667.667 0 1 1 0-1.333z",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M11.885 16H7.8v-.588q.518 0 .755-.07.236-.078.236-.352 0-.192-.077-.39l-.409-1.023H5.493l-.211.563q-.18.472-.179.684 0 .383.294.486.3.102.697.102V16H3.109v-.588q.357 0 .607-.134.25-.135.473-.505.23-.377.492-1.061l2.5-6.546h.607l2.64 6.75q.287.716.421.972a1 1 0 0 0 .371.39q.237.135.665.134zm-3.81-3.049L6.88 9.928 5.742 12.95z"
      }
    )
  );
};
export default BlockAgreement;
